/* Dansk katalog for locale-no.js (del 3 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'set.import.packages.statusUploaded': 'Uploadet',
  'set.import.packages.uploadedAt': 'Uploadet {date}',
  'set.import.packages.readAt': 'Senest aflæst {date}',
  'set.import.packages.importedAt': 'Importeret til regnskabet {date}',
  'set.import.packages.notAvailable': 'Ukendt tidspunkt',
  'set.import.packages.unknownSize': 'Ukendt størrelse',
  'set.import.packages.deleteConfirm': 'Slet {name}? ZIP-filen og midlertidige analysedata fjernes permanent. Der er ikke importeret regnskabsdata fra denne pakke.',
  'set.import.packages.deletePreviousConfirm': 'Slette den tidligere importpakke {name}? Importerede regnskabsdata bliver liggende. Dokumenter, der kun findes i denne ældre ZIP-fil, kan ikke åbnes efter sletning.',
  'set.import.packages.deleteDialogTitle': 'Slet importpakke?',
  'set.import.packages.deleteDialogBody': 'Du er ved at slette {name}. ZIP-filen og tilhørende analysedata fjernes permanent fra backend.',
  'set.import.packages.deletePreviousBody': 'Du er ved at slette den tidligere importpakke {name}. Regnskabsdata bliver liggende, men dokumenter, der kun findes i denne ZIP-fil, kan ikke åbnes bagefter.',
  'set.import.packages.deleteIrreversible': 'Denne handling kan ikke fortrydes.',
  'set.import.packages.replaceTitle': 'Erstat eksisterende importpakke?',
  'set.import.packages.replaceBody': 'Du har allerede importpakken {name}. Når den nye pakke er analyseret og godkendt, bliver den nye aktiv, og alle ældre ZIP-pakker slettes fra backend.',
  'set.import.packages.replaceSafety': 'Den eksisterende pakke bevares, mens den nye uploades og analyseres. Hvis analysen mislykkes eller afbrydes, forbliver den nuværende aktive pakke uberørt.',
  'set.import.packages.replacePermanent': 'Efter godkendelse kan sletning af den gamle pakke ikke fortrydes.',
  'set.import.packages.chooseReplacement': 'Vælg ny ZIP',
  'set.import.packages.deleteProtected': 'Pakken bruges i regnskabet og kan ikke slettes her.',
  'set.import.packages.protectedHelp': 'Dette er den aktive kilde til importerede bilagsdokumenter og kan derfor ikke slettes.',
  'set.import.packages.duplicateHelp': 'Filindholdet er identisk med den aktive importpakke og kan slettes.',
  'set.import.packages.deleting': 'Sletter...',
  'set.import.packages.delete': 'Slet',
  'set.import.packages.deleted': 'Importpakken er slettet.',
  'set.import.packages.deleteFailed': 'Kunne ikke slette importpakken.',
  'set.import.packages.deleteMissing': 'Lagringssti for importpakken mangler.',
  'set.import.packages.download': 'Download ZIP',
  'set.import.packages.downloading': 'Klargør...',
  'set.import.packages.downloadMissing': 'Lagringssti for importpakken mangler.',
  'set.import.packages.downloadStarted': 'Download af original ZIP er startet.',
  'set.import.packages.downloadFailed': 'Kunne ikke downloade importpakken.',
  'set.import.years.title': 'Vælg dataår',
  'set.import.years.help': 'Kun data og tal for de valgte år importeres. Registre og dokumentarkivet behandles separat.',
  'set.import.years.recommended': 'Anbefalet periode',
  'set.import.years.previousOnly': 'Kun tidligere år',
  'set.import.years.all': 'Alle år',
  'set.import.years.current': 'indeværende år',
  'set.import.years.retentionWarning': 'Du har fravalgt {years}, som kan ligge inden for den normale opbevaringsperiode. Sørg for, at materialet opbevares et andet sted.',
  'set.import.years.documentsPreserved': 'Original-ZIP og dokumentarkiv bevares komplet uanset årsvalget.',
  'set.import.years.importedTitle': 'Importerede dataår',
  'set.import.years.importedHelp': 'Du kan fjerne importerede tal for ét år uden at slette ZIP, dokumentarkiv eller manuelt oprettede poster.',
  'set.import.years.removeYear': 'Fjern importerede data for {year}',
  'set.import.years.removeTitle': 'Fjern importerede data for {year}?',
  'set.import.years.removeBody': 'Importeret åbningsbalance, rapporthistorik, årsspecifikke åbne poster og importerede kontrolstatusser for {year} fjernes.',
  'set.import.years.removePreserves': 'Manuelle fakturaer, køb, bilag, registre, original-ZIP og dokumentarkiv bevares.',
  'set.import.years.removeConfirm': 'Fjern data',
  'set.import.years.removing': 'Fjerner...',
  'set.import.years.removed': 'Fjernede {count} importerede datapunkter for {year}.',
  'set.import.years.removeFailed': 'Kunne ikke fjerne importerede årsdata.',
  'set.import.years.invalid': 'Vælg et gyldigt importår.',
  'set.import.years.selectedLedgerRows': 'historiklinjer i de valgte år',
  'set.showAll': 'Vis alle',
  'set.count.accounts': 'saldokonti',
  'set.count.customers': 'kunder',
  'set.count.products': 'produkter',
  'set.count.openSalesInvoices': 'åbne kundefakturaer',
  'set.count.openPurchaseInvoices': 'åbne leverandørfakturaer',
  'set.count.suppliers': 'leverandører',
  'set.count.openingBalances': 'åbningsbalancer',
  'set.import.after': 'Efter import',
  'set.noMatches': 'Ingen resultater.',
  'set.preview': 'Forhåndsvisning',
  'set.previewHeading': 'Sådan ser dokumentet ud',
  'set.preview.sender': 'Afsender:',
  'set.preview.invoiceNo': 'Fakturanr.:',
  'set.preview.invoiceDate': 'Fakturadato:',
  'set.preview.dueDate': 'Forfaldsdato:',
  'set.preview.accountNo': 'Kontonr.:',
  'set.preview.toPay': 'At betale:',
  'set.preview.docType': 'FAKTURA',
  'set.preview.noCustomer': 'Ingen kunde valgt endnu',
  'set.preview.net': 'Netto',
  'set.preview.vat': 'Moms',
  'set.preview.toPayShort': 'At betale',
  'set.menu.title': 'Sidemenu',
  'set.menu.help': 'Vælg, hvilke sider der vises i menuen til venstre. Kernesider er altid synlige.',
  'set.menu.showAll': 'Vis alle sider',
  'set.xlsx': 'XLSX',
  'set.csv': 'CSV',
  'set.import': 'Importér',
  'set.data.accountingTitle': 'Import / Eksport af regnskab',
  'set.data.accountingSub': 'Importér fra et andet regnskabssystem med én eller flere ZIP-, SAF-T-, CSV- eller Excel-filer, og eksportér backup og bogføringsoversigt.',
  'set.export': 'Eksportér',
  'set.data.invoiceCsv': 'Faktura CSV',
  'set.data.invoiceTemplate': 'Skabelon til fakturaimport',
  'set.data.bookkeepingCsv': 'Bogføring CSV',
  'set.data.reusePackage': 'Bruger den uploadede eksportfil igen uden ny upload.',
  'set.data.resetAll': 'Nulstil alle data',
  'set.data.deleteBusiness': 'Slet virksomhed',
  'set.data.onlyOwnerSchedule': 'Kun ejeren kan planlægge sletning.',
  'set.doc.tab': 'Dokumenter',
  'svc.mcpMissingRedirect': 'MCP-tjenesten returnerede ingen sikker omdirigering.',
  'route.dailySettlements': 'Dagsopgørelser',
  'nav.dailySettlements': 'Dagsopgørelser',
  'navhelp.dailySettlements': 'Dagsopgørelser fra kassesystemer, bookingsystemer, udlejningsplatforme og webshops. Kontrollér og godkend før bogføring.',
  'dailySettlement.title': 'Dagsopgørelser',
  'dailySettlement.sub': 'Opgørelser fra kasse, booking, udlejning og webshop. Intet bogføres, før du godkender det.',
  'dailySettlement.refresh': 'Opdater',
  'dailySettlement.loadError': 'Kunne ikke hente dagsopgørelserne.',
  'dailySettlement.openSettings': 'Åbn integrationer',
  'dailySettlement.emptyTitle': 'Ingen dagsopgørelser her',
  'dailySettlement.emptyText': 'Når en kilde er tilsluttet og har leveret en opgørelse, dukker den op her til kontrol og godkendelse.',
  'dailySettlement.filter.open': 'Til behandling',
  'dailySettlement.filter.ready': 'Klar',
  'dailySettlement.filter.review': 'Skal kontrolleres',
  'dailySettlement.filter.done': 'Færdig',
  'dailySettlement.status.ready': 'Klar til godkendelse',
  'dailySettlement.status.review': 'Skal kontrolleres',
  'dailySettlement.status.approved': 'Bogført',
  'dailySettlement.status.dismissed': 'Afsluttet uden bogføring',
  'dailySettlement.attentionTitle': 'Kilder, der kræver opmærksomhed',
  'dailySettlement.attentionStale': '{provider} har ikke leveret en opgørelse i {days} dage. Den seneste var {date}.',
  'dailySettlement.attentionNever': '{provider} er tilsluttet, men har aldrig leveret en opgørelse.',
  'dailySettlement.homeWaiting': '{ready} klar til godkendelse, {review} skal kontrolleres.',
  'dailySettlement.homeAction': 'Se dagsopgørelser',
  'set.doc.title': 'Dokumenter',
  'set.doc.sub': 'Upload og opbevar dine egne dokumenter, fx aftaler, forsikringer eller vedtægter.',
  'set.doc.drop': 'Træk filer hertil',
  'set.doc.dropHint': 'Eller tryk for at vælge en fil',
  'set.doc.empty': 'Ingen dokumenter uploadet endnu.',
  'set.doc.added': 'Tilføjet',
  'set.doc.new': 'Nyt dokument',
  'set.doc.edit': 'Redigér dokument',
  'set.doc.remove': 'Fjern dokument',
  'set.doc.open': 'Åbn dokument',
  'set.doc.add': 'Tilføj dokument',
  'set.doc.name': 'Navn',
  'set.doc.namePh': 'Fx Ansvarsforsikring 2026',
  'set.doc.nameRequired': 'Giv dokumentet et navn først',
  'set.doc.type': 'Type',
  'set.doc.attachTo': 'Vedhæftes som standard i',
  'set.doc.attachToHint': 'Dokumentet følger automatisk med disse dokumenttyper til kunden — kan fjernes pr. afsendelse.',
  'set.doc.uploading': 'Uploader...',
  'set.doc.uploaded': 'Dokument uploadet',
  'set.doc.saved': 'Dokument opdateret',
  'set.doc.deleted': 'Dokument fjernet',
  'set.doc.deleteConfirm': 'Slette dokumentet «{name}»?',
  'set.doc.fileHint': 'PDF, Word, Excel, JPG, PNG eller WEBP. Maks. 10 MB.',
  'set.doc.unavailable': 'Dokumentsiden blev ikke indlæst. Genindlæs siden — vises den stadig tom, er det en fejl, vi skal se på.',
  'set.doc.target.offer': 'Tilbud',
  'set.doc.target.orderConfirmation': 'Ordrebekræftelser',
  'set.doc.target.invoice': 'Faktura',
  'set.doc.target.creditNote': 'Kreditnota',
  'set.doc.target.subscription': 'Abonnement og lister',
  'set.doc.target.subscriptionHint': 'Følger med e-mails, du sender fra et abonnement eller en kundeliste.',
  'set.doc.kind.agreement': 'Aftale',
  'set.doc.kind.insurance': 'Forsikring',
  'set.doc.kind.articles': 'Vedtægter / stiftelsesdokument',
  'set.doc.kind.authorization': 'Fuldmagt',
  'set.doc.kind.certificate': 'Certifikat',
  'set.doc.kind.standard_attachment': 'Standardbilag',
  'set.doc.kind.other': 'Andet',
  'sale.att.standard': 'Standard',
  'sale.att.removeStandard': 'Medtag ikke denne gang',
  'sale.att.remove': 'Fjern vedhæftning',
  'sub.standardDocs': 'Standarddokumenter, der følger med: {names}',
  'set.data.saftXml': 'SAF-T XML (beta)',
  'set.acc.title': 'Regnskabsopsætning',
  'set.acc.sub': 'Grundindstillinger for regnskabet: første regnskabsår, momsregistrering, regnskabsmetode og lignende.',
  'set.acc.startYear': 'Startår',
  'set.acc.startYearHelp': 'Det første regnskabsår, du fører i Plumme. Bilag og rapporter før dette år hører hjemme i et tidligere system.',
  'set.acc.startInvoiceNo': 'Første fakturanummer',
  'set.acc.startInvoiceNoHelp': 'Det nummer, din første faktura skal have. Kommer du fra et andet system, så sæt det højere end det sidst brugte nummer, så du får en sammenhængende nummerrække (et lovkrav).',
  'set.acc.vatStatus': 'Momsstatus',
  'set.acc.vatStatusHelp': 'Om virksomheden er registreret i Merverdiavgiftsregisteret. Du bliver momspligtig, når den momspligtige omsætning passerer 50 000 kr på 12 måneder. Momsregistreret betyder, at du opkræver moms på salg og får fradrag på køb.',
  'set.acc.vatRegistered': 'Momsregistreret',
  'set.acc.notVatRegistered': 'Ikke momsregistreret',
  'set.acc.vatRegisteredFrom': 'Momsregistreret fra',
  'set.acc.vatRegisteredWhen': 'Var virksomheden momsregistreret allerede 1. januar {year}?',
  'set.acc.vatRegisteredWhenHelp': 'Regnskabet i Plumme starter {year}. Fra momsdatoen beregnes moms på salg og køb — før den ingen. Svarer du «ja», sættes datoen til 1. januar {year}.',
  'set.acc.vatRegisteredPick': 'Vælg svar',
  'set.acc.vatRegisteredAtStart': 'Ja, registreret før {year}',
  'set.acc.vatRegisteredLater': 'Nej, registreret i løbet af {year} eller senere',
  'set.acc.vatRegisteredUnknown': 'Ved ikke',
  'set.acc.vatRegisteredFromHelp': 'Datoen, hvor virksomheden blev momsregistreret. Før denne dato beregnes ingen moms; fra og med den bogføres moms på salg og køb.',
  'set.acc.standardVat': 'Forslag på nye salgslinjer',
  'set.acc.standardVatHelp': 'Dette er kun den sats, Plumme foreslår, når du opretter en ny salgslinje. Virksomheden kan bruge flere momssatser, og produktet eller fakturalinjen kan tilsidesætte forslaget.',
  'set.acc.howFileVat': 'Hvordan indberetter du moms',
  'set.acc.vatPeriod': 'Momsperiode',
  'set.acc.vatPeriodHelp': 'Hvor ofte du indsender mva-melding. De fleste indsender hver anden måned (6 perioder om året). Små virksomheder under 1 mio. kr kan søge om årlig indberetning. Kvartalsvis og månedlig bruges i særlige tilfælde.',
  'set.acc.midYearTitle': 'Start midt i året (starttal)',
  'set.acc.midYearHelp': 'Brug denne, hvis du tager Plumme i brug midt i et regnskabsår. Så indtaster du starttal — salg, omkostninger og moms indtil videre i året — fra det gamle system, så årsrapporter og mva-melding fortsætter med de rigtige tal.',
  'set.acc.midYear': 'Start midt i året',
  'set.acc.enterOpening': 'Indtast starttal',
  'set.acc.enterOpeningHelp': 'Åbner formularen, hvor du angiver overgangsdato, moms indtil videre og salg/omkostninger fordelt på konto fra det tidligere system.',
  'set.acc.ibHelp': 'Åbningsbalancen er de aktiver, den egenkapital og den gæld, selskabet havde ved årets begyndelse — altså ultimobalancen fra sidste år. Indtast den, når du starter et nyt regnskabsår i Plumme, så balancen stemmer fra dag ét.',
  'set.acc.viewIb': 'Se / rediger åbningsbalance',
  'set.acc.viewIbHelp': 'Åbner den åbningsbalance, du har bogført, hvor du kan se linjerne, redigere dem eller slette balancen.',
  'set.acc.addIb': 'Indtast åbningsbalance',
  'set.acc.addIbHelp': 'Åbner en guide, der hjælper dig med at opsætte åbningsbalancen — du bekræfter startdato og indtaster balancelinjerne (debet/kredit) fra sidste år.',
  'set.acc.extraAccountsHelp': 'Tilføj kun ekstra konti, når saldobalancen eller eksporten kræver dem.',
  'set.acc.searchPlaceholder': 'Søg i kontoplanen på nummer eller navn',
  'set.acc.searchNoHits': 'Ingen konti matcher «{query}».',
  'set.acc.addAccount': 'Tilføj konto',
  'set.acc.addAccountHelp': 'Opretter en brugerdefineret konto i kontoplanen. Brug det kun, når en konto, du har brug for, mangler — de fleste standardkonti findes allerede.',
  'set.acc.accountNameHelp': 'Et beskrivende navn på kontoen, som det vises i kontoplanen og rapporterne — f.eks. «Software/abonnement».',
  'set.acc.accountNoHelp': 'Firecifret kontonummer. Første ciffer bestemmer kontoklassen: 1 aktiver, 2 egenkapital/gæld, 3 indtægter, 4–7 omkostninger, 8 finans og skat.',
  'set.acc.accountClass': 'Kontoklasse',
  'set.acc.accountClassHelp': 'Den hovedgruppe, kontoen havner i, udledt automatisk af første ciffer i kontonummeret. Den styrer, om kontoen er et aktiv, gæld, indtægt eller omkostning.',
  'set.acc.equivalent': 'Svarer til konto',
  'set.acc.equivalentHelp': 'Kobler den brugerdefinerede konto til en standardkonto. Det fortæller Plumme, hvordan kontoen skal behandles i årsafslutning og skattemelding — så egne konti havner rigtigt i de offentlige skemaer.',
  'set.acc.createAccount': 'Opret konto',
  'set.acc.ownAccounts': 'Egne konti',
  'set.acc.ownAccountsHelp': 'De konti, du selv har tilføjet ud over standardkontoplanen. Kun disse kan ændres eller slettes.',
  'set.acc.noOwnAccounts': 'Ingen egne konti endnu.',
  'set.acc.removeAccount': 'Fjern konto',
  'set.acc.deactivated': 'deaktiveret',
  'set.acc.standardAccounts': 'Standardkonti',
  'set.acc.standardAccountsHelp': 'Den indbyggede standardkontoplan (NS 4102). Disse er fælles for alle og bruges automatisk, når du bogfører — du behøver sjældent at tilføje egne.',
  'set.bank.title': 'Bankafstemning',
  'set.bank.help': 'Bankafstemning hjælper dig med at kontrollere, at køb, salg og betalinger er bogført én gang og stemmer med driftskontoen.',
  'set.bank.activeFrom': 'Aktiv fra',
  'set.bank.accounts': 'Bankkonti',
  'set.bank.primaryHelp': 'Den primære fakturakonto er den standardkonto, kunderne betaler til.',
  'set.bank.disabled': 'Deaktiveret',
  'set.bank.invoiceAccount': 'Fakturakonto',
  'set.bank.activate': 'Aktiver konto',
  'set.bank.setAsInvoice': 'Angiv som fakturakonto',
  'set.bank.accountNumber': 'Kontonummer',
  'set.bank.ledgerAccount': 'Konto i regnskabet',
  'set.bank.type': 'Type',
  'set.bank.typeOperating': 'Drift',
  'set.bank.typeTax': 'Skattetræk',
  'set.bank.typeSavings': 'Opsparing',
  'set.bank.typePrivate': 'Privat',
  'set.bank.typeOther': 'Andet',
  'set.bank.openingBalance': 'Startsaldo for bankafstemning',
  'set.bank.openingBalanceDate': 'Dato for startsaldo',
  'set.bank.reconcileIn': 'Afstem i Bank',
  'set.bank.mustReconcile': 'Skal afstemmes',
  'set.bank.showInPayments': 'Vis i Betalt fra/til',
  'set.bank.none': 'Der er endnu ikke registreret nogen bankkonti.',
  'set.bank.cards': 'Kort knyttet til kontoen',
  'set.bank.cardsHelp': 'Kvitteringer viser ofte kun de sidste fire cifre. Registrér kortet, så genkender Plumme betalingen uden at vente på kontoudtoget. Kontotypen afgør, om købet bliver virksomhedens eller et privat udlæg.',
  'set.bank.cardsNone': 'Kontoen har ingen kort',
  'set.bank.cardsNoneHelp': 'Sæt kryds her, eller registrér kortene, på hver betalingskonto. Når alle konti er afklaret, ved Plumme, hvilke kort virksomheden har: en kvittering betalt med et andet kort foreslås så som privat udlæg med en bemærkning på bilaget.',
  'set.bank.cardPromptTitle': 'Kortene afgør virksomhed eller privat',
  'set.bank.cardPromptBody': 'Plumme aflæser kortnummeret på kvitteringen. Ved vi, hvilke kort virksomheden har, afgøres hvert kortkøb automatisk: kender vi kortet, bliver det et virksomhedskøb — er det et andet kort, bliver det et privat udlæg. Disse konti mangler svar:',
  'set.bank.cardPromptSkipHelp': 'Springer du over, forbliver kontoen uafklaret, og kortkvitteringer skal have betalingskilde manuelt. Du kan udfylde det når som helst.',
  'set.bank.cardPromptFill': 'Udfyld nu',
  'set.bank.cardPromptSkip': 'Gem uden',
  'set.bank.accountFallback': 'Bankkonto',
  'set.bank.receiptDefault': 'Standardbetalingskilde for bilag',
  'set.bank.receiptDefaultSub': 'Bruges kun, når hverken kort, kontoudtog eller historik viser, hvorfra købet blev betalt.',
  'set.bank.receiptDefaultLabel': 'Betalingskilde',
  'set.bank.receiptDefaultHint': 'Bilaget bliver klar til bogføring, men markeres orange med, at kilden er forvalgt og ikke aflæst fra dokumentet.',
  'set.bank.receiptDefaultNone': 'Ingen – lad bilaget stå til kontrol',
  'set.bank.cardLast4': 'Sidste fire cifre',
  'set.bank.cardLabel': 'Navn på kortet',
  'set.bank.cardLabelPh': 'F.eks. Visa privat',
  'set.bank.cardAdd': 'Tilføj kort',
  'set.bank.cardRemove': 'Fjern kort',
  'set.bank.cardLast4Invalid': 'Skriv de sidste fire cifre på kortet.',
  'set.bank.cardDuplicate': 'Kortet er allerede registreret. To kort med de samme fire cifre kan ikke skelnes fra hinanden på en kvittering.',
  'set.access.title': 'Adgang',
  'set.access.sub': 'Invitér bogholder eller samarbejdspartner med eget login. Adgang styres med roller.',
  'set.access.activeBusiness': 'Aktiv virksomhed',
  'set.access.active': 'Aktiv',
  'set.access.noBusinesses': 'Ingen virksomheder er knyttet til brugeren endnu.',
  'set.access.newBusiness': 'Ny virksomhed',
  'set.access.inviteTitle': 'Invitér samarbejdspartner',
  'set.access.inviteSub': 'Invitér bogholder eller andre samarbejdspartnere, og se ventende invitationer.',
  'set.access.noAdmin': 'Du har ikke administratorrolle i den valgte virksomhed.',
  'set.access.noAdminSub': 'Kun ejer og administrator kan invitere nye brugere.',
  'set.access.email': 'E-mail',
  'set.access.role': 'Rolle',
  'set.role.accountant': 'Bogholder',
  'set.role.admin': 'Admin',
  'set.role.viewer': 'Læseadgang',
  'set.access.sendInvite': 'Send invitation',
  'set.access.invites': 'Invitationer',
  'set.access.invitesSub': 'Ventende invitationer for den aktive virksomhed.',
  'set.access.accept': 'Acceptér',
  'set.access.pending': 'Venter',
  'set.access.withdraw': 'Træk tilbage',
  'set.access.noInvites': 'Ingen ventende invitationer.',
  'set.access.deleteNote': 'Sletter kun den valgte virksomhed, ikke dit login eller andre virksomheder.',
  'set.access.deleteBusiness': 'Slet denne virksomhed',
  'set.access.onlyOwnerDelete': 'Kun ejeren kan slette virksomheder.',
  'set.saveChanges': 'Gem ændringer',
  'set.title': 'Indstillinger',
  'set.subtitle': 'Virksomhed, brugerprofil, adgang, regnskab, bank, investeringer og data ét sted.',
  'set.tabsTitle': 'Indstillingsfaner',
  'set.tabsHelp': 'Hver fane er et indstillingsområde: Virksomhed (firmaoplysninger), Brugerprofil (dig), Adgang (hvem der må gøre hvad), Præferencer (notifikationer og visning), Regnskab (opsætning og kontoplan), Bank, Investeringer, Data (import/eksport), Dokumenter, Integrationer og Abonnement.',
  'set.company': 'Virksomhed',
  'set.country': 'Land',
  'set.companyName': 'Virksomhedsnavn',
  'set.orgNumber': 'Organisationsnummer',
  'set.phone': 'Telefon',
  'set.address': 'Adresse',
  'set.zip': 'Postnr.',
  'set.city': 'By',
  'set.companyType': 'Selskabsform',
  'set.logo': 'Firmalogo',
  'set.logoAlt': 'logo',
  'set.logoHelp': 'Logo til faktura. PNG, JPG eller WebP, maks. 1 MB.',
  'set.uploadLogo': 'Upload logo',
  'set.previewInvoice': 'Forhåndsvis faktura',
  'set.deleteLogo': 'Slet logo',
  'set.inboxEmail': 'E-mail til bilagsindbakke',
  'set.inboxEmailHelp': 'Videresend leverandørfakturaer og kvitteringer hertil for at lægge bilag direkte i indbakken.',
  'set.copyEmail': 'Kopiér e-mail',
  'set.generateEmail': 'Generér ny e-mail',
  'set.generateEmailHelp': 'Skift kun, hvis adressen er lækket eller modtager spam. Eksisterende integrationer skal opdateres.',
  'set.profile': 'Brugerprofil',
  'set.profileSub': 'Oplysninger, der hører til dit login.',
  'set.loggedInEmail': 'Logget ind med e-mail',
  'set.mobile': 'Mobilnummer',
  'set.saveProfile': 'Gem brugerprofil',
  'set.subscription': 'Abonnement',
  'set.subscriptionSub': 'Fakturering styres af backend og Stripe, ikke en lokal mockplan.',
  'set.openPortal': 'Åbn kundeportal',
  'set.current': 'Nuværende',
  'adv.eyebrow': 'Økonomisk rådgiver',
  'adv.beta': 'Beta',
  'adv.updating': 'Opdaterer',
  'adv.lead': 'SuperPlumma analyserer dit regnskab og giver dig råd som en erfaren økonomichef — for {year}.',
  'adv.tab.overview': 'Oversigt',
  'adv.tab.liquidity': 'Likviditet & risiko',
  'adv.tab.sales': 'Salg & rentabilitet',
  'adv.tab.costs': 'Omkostninger',
  'adv.sales.title': 'Salg og rentabilitet',
  'adv.sales.sub': 'Bogførte salgsfakturaer for {year}',
  'adv.sales.help': 'Alle tal her er beregnet ud fra bogførte salgsfakturaer i det valgte år, sammenlignet med de samme tal året før. Kladder, kreditnotaer og tilbud er ikke med.',
  'adv.sales.emptyTitle': 'Ingen bogførte salgsfakturaer endnu',
  'adv.sales.emptyText': 'Når du har bogført salg, beregner jeg kunderentabilitet, betalingstid, rabatniveau og hvilke produkter der vokser.',
  'adv.sales.periodYear': 'i {year}',
  'adv.sales.periodVsPrev': 'mod {year}',
  'adv.sales.invoiceCount': '{count} fakturaer',
  'adv.sales.customerCount': '{count} kunder',
  'adv.sales.recurringCount': '{count} med gentagende fakturering',
  'adv.sales.days': '{days} dage',
  'adv.sales.noPayments': 'Intet betalt endnu',
  'adv.sales.kpi.revenue': 'Omsætning',
  'adv.sales.kpi.growth': 'Omsætningsvækst',
  'adv.sales.kpi.growthHelp': 'Ændring i bogført salg i forhold til samme periode året før. Vises som »—«, hvis der ikke findes sidste års tal at sammenligne med.',
  'adv.sales.kpi.avgInvoice': 'Gns. fakturabeløb',
  'adv.sales.kpi.discount': 'Gns. rabat',
  'adv.sales.kpi.discountHelp': 'Samlet rabat divideret med, hvad fakturaerne ville have været værd uden rabat. Stiger tallet, uden at volumen stiger, giver du margin væk uden at få noget igen.',
  'adv.sales.kpi.paymentDays': 'Betalingstid',
  'adv.sales.kpi.paymentDaysHelp': 'Gennemsnitligt antal dage fra fakturadato til registreret betaling. Kun betalte fakturaer tæller med — ubetalte trækker ikke gennemsnittet op.',
  'adv.sales.kpi.repeat': 'Genkøbsrate',
  'adv.sales.kpi.repeatHelp': 'Andel af kunder med mere end én faktura i året. En høj genkøbsrate giver mere forudsigelig omsætning end det samme salg spredt på engangskunder.',
  'adv.sales.kpi.concentration': 'Kundekoncentration',
  'adv.sales.kpi.concentrationHelp': 'Hvor stor en andel af omsætningen der kommer fra den største kunde. Over 40 % betyder, at én kunde alene kan vælte driften.',
  'adv.sales.kpi.recurring': 'Tilbagevendende indtægt',
  'adv.sales.kpi.recurringHelp': 'Andel af omsætningen, der kommer fra fakturaer med gentagen fakturering eller abonnement.',
  'adv.sales.customers': 'Kunderentabilitet',
  'adv.sales.customersSub': 'Omsætning, betalingstid og rabatniveau pr. kunde',
  'adv.sales.customersHelp': 'Kunderne er sorteret efter omsætning i det valgte år. Trenden sammenligner med sidste år — en ny kunde uden tal fra sidste år får sit eget mærke i stedet for en pil.',
  'adv.sales.col.customer': 'Kunde',
  'adv.sales.col.revenue': 'Omsætning',
  'adv.sales.col.grossProfit': 'Bruttofortjeneste',
  'adv.sales.col.paymentSpeed': 'Betalingstid',
  'adv.sales.col.discount': 'Rabat',
  'adv.sales.col.jobs': 'Fakturaer',
  'adv.sales.col.trend': 'Trend',
  'adv.sales.partialProfit': 'Ikke beregnet',
  'adv.sales.trendNew': 'Ny kunde i år',
  'adv.sales.showAll': 'Vis alle {count} kunder',
  'adv.sales.showFewer': 'Vis færre',
  'adv.sales.profitNote': 'Bruttofortjeneste vises, når alle fakturalinjer for kunden har registreret kostpris. Ældre fakturaer og linjer uden kostpris vises som »Ikke beregnet«.',
  'adv.sales.products': 'Produkter og tjenester',
  'adv.sales.productsSub': 'Omsætning pr. produkt, og hvad der vokser eller falder',
  'adv.sales.productsHelp': 'Produkterne er hentet fra fakturalinjerne. Linjer uden produktnavn samles under »Uden produktnavn«. Vækst og fald måles mod samme produkt året før.',
  'adv.sales.topRevenue': 'Størst omsætning',
  'adv.sales.growing': 'Størst vækst',
  'adv.sales.falling': 'Størst fald',
  'adv.sales.noComparison': 'Ingen tal fra sidste år at sammenligne med',
  'adv.sales.verdictTag': 'Salg og rentabilitet lige nu',
  'adv.sales.verdict.concentration': '{name} står for {pct} % af fakturasalget på {revenue}. Det er den største risiko i dit salg lige nu — falder den kunde fra, forsvinder størstedelen af omsætningen med den.',
  'adv.sales.verdict.slowPayers': 'Salget i sig selv ser fint ud, men {count} kunde(r) betaler langsomt — den langsomste bruger {days} dage. Pengene er optjent; de står bare ude længere, end de behøver.',
  'adv.sales.verdict.discounts': 'Du giver i gennemsnit {pct} % rabat, i alt {amount} i år. Det er penge, du allerede har solgt for — værd at tjekke, at rabatten faktisk giver mere volumen.',
  'adv.sales.verdict.growing': 'Salget vokser {pct} % i forhold til sidste år og ligger nu på {revenue}. Intet i salgstallene kræver handling lige nu — det vigtigste er at holde det kørende.',
  'adv.sales.verdict.shrinking': 'Salget er faldet {pct} % i forhold til sidste år og ligger på {revenue}. Det er det tydeligste signal i dine salgstal lige nu.',
  'adv.sales.verdict.steady': 'Salget ligger på {revenue} fordelt på {count} fakturaer. Jeg ser ingen røde flag i salgstallene — tiltagene nedenfor er muligheder, ikke problemer.',
  'adv.sales.moves.title': 'Det her ville jeg gøre først',
  'adv.sales.moves.sub': 'Prioriterede tiltag, sorteret efter effekt',
  'adv.sales.moves.help': 'Hvert tiltag har et tal bag sig fra dine egne fakturaer. Effekttypen fortæller, hvilken slags størrelse tallet er — dage, kroner eller andel — og de må aldrig lægges sammen.',
  'adv.sales.move.chaseSlowPayers.title': 'Følg op på de langsomste betalere',
  'adv.sales.move.chaseSlowPayers.text': '{count} kunde(r) betaler langsommere end resten. {name} bruger i gennemsnit {days} dage.',
});
